import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7857c1ca")

_pushScopeId("data-v-7857c1ca")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "患者の仮登録", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("患者リストに無い初診の患者様を予約登録する場合は以下を入力して予約してください。")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("名前 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("性別 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("電話番号 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_description = _resolveComponent("description")
  const _component_validate_edit_box = _resolveComponent("validate-edit-box")
  const _component_radio_button_group = _resolveComponent("radio-button-group")
  const _component_alert_message = _resolveComponent("alert-message")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_description, null, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_item_frame, null, {
        default: _withId(() => [
          _createVNode(_component_validate_edit_box, {
            class: "vue-content-edit-box",
            title: "氏名",
            placeholder: "患者様のお名前",
            required: true,
            validation: _ctx.submitted ? _ctx.nameError : undefined,
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["validation", "modelValue"]),
          _createVNode(_component_radio_button_group, {
            "group-id": "gender",
            radios: _ctx.genders,
            modelValue: _ctx.gender,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.gender = $event)),
            required: true
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["radios", "modelValue"]),
          (_ctx.submitted && _ctx.genderError)
            ? (_openBlock(), _createBlock(_component_alert_message, { key: 0 }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.genderError), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_validate_edit_box, {
            class: "vue-content-edit-box",
            title: "電話番号",
            placeholder: "電話番号（ハイフンなし）",
            required: false,
            validation: _ctx.submitted ? _ctx.phoneNumberError : undefined,
            modelValue: _ctx.phoneNumber,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phoneNumber = $event))
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["validation", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})